import {
  FavoriteBrand,
  FavoriteBrandData,
  FavoriteItem,
  FavoriteItemData,
  favorite,
} from 'mostra';

const {
  SnapShotByItem,
  SnapShotByBrand,
} = favorite;
export {
  FavoriteBrand,
  FavoriteBrandData,
  FavoriteItem,
  FavoriteItemData,
  SnapShotByItem,
  SnapShotByBrand,
};

export default favorite;

// import { firebase } from 'mostra';
// // import * as firebase from '@/plugins/firebase';
// import { cloneT } from '@/modules/tools';
// import { collectionNames, FirebaseID, FirestoreDate } from '@/modules/firestore';
//
// export type FavoriteBrandData = {
//   owner: FirebaseID;
//   brandId: FirebaseID;
//
//   // SYSTEM-BASE
//   checked: boolean; // 有効フラグ
//
//   registeredDate: FirestoreDate | null;
//   createdBy: FirebaseID | null;
//   createdDt: FirestoreDate | null;
//   updatedBy: FirebaseID | null;
//   updatedDt: FirestoreDate | null;
//
// }
//
// export type FavoriteItemData = {
//   owner: FirebaseID;
//   itemId: FirebaseID;
//   brandId: FirebaseID;
//
//   // SYSTEM-BASE
//   checked: boolean; // 有効フラグ
//   registeredDate: FirestoreDate | null;
//   createdBy: FirebaseID | null;
//   createdDt: FirestoreDate | null;
//   updatedBy: FirebaseID | null;
//   updatedDt: FirestoreDate | null;
//
// }
//
// export type FavoriteItem = {
//   id: FirebaseID | null;
//   data: FavoriteItemData;
// }
//
// export type FavoriteBrand = {
//   id: FirebaseID | null;
//   data: FavoriteBrandData;
//   items: FavoriteItem[];
// }
//
// const defalutFavoriteBrandData: FavoriteBrandData = {
//
//   owner: '',
//   brandId: '',
//
//   // SYSTEM-BASE
//   checked: true, // 有効フラグ
//
//   registeredDate: null,
//   createdBy: null,
//   createdDt: null,
//   updatedBy: null,
//   updatedDt: null,
// };
//
// const defalutFavoriteItemData: FavoriteItemData = {
//
//   owner: '',
//   brandId: '',
//   itemId: '',
//
//   // SYSTEM-BASE
//   checked: true, // 有効フラグ
//
//   registeredDate: null,
//   createdBy: null,
//   createdDt: null,
//   updatedBy: null,
//   updatedDt: null,
// };
//
// const createNewFavoriteBrand = (owner: FirebaseID, brandId: FirebaseID): FavoriteBrand => {
//   const data = cloneT<FavoriteBrandData>(defalutFavoriteBrandData);
//   data.owner = owner;
//   data.brandId = brandId;
//   return {
//     id: null,
//     data,
//     items: [],
//   };
// };
//
// const createNewFavoriteItem = (owner: FirebaseID, brandId: FirebaseID, itemId: FirebaseID): FavoriteItem => {
//   const data = cloneT<FavoriteItemData>(defalutFavoriteItemData);
//   data.owner = owner;
//   data.brandId = brandId;
//   data.itemId = itemId;
//   return {
//     id: null,
//     data,
//   };
// };
//
// const favoriteaAllRef = (owner: FirebaseID) => firebase.db()
//   .collection(collectionNames.user)
//   .doc(owner)
//   .collection(collectionNames.favoriteBrand);
//
// const favoriteBrandRef = (owner: FirebaseID, brandId: FirebaseID) => favoriteaAllRef(owner)
//   .doc(brandId);
//
// const favoriteItemsRef = (owner: FirebaseID, brandId: FirebaseID) => favoriteBrandRef(owner, brandId)
//   .collection(collectionNames.favoriteItem);
//
// const favoriteItemRef = (owner: FirebaseID, brandId: FirebaseID, itemId: FirebaseID) => favoriteItemsRef(owner, brandId)
//   .doc(itemId);
//
// const favoriteBrandGroupRef = () => firebase.db()
//   .collectionGroup(collectionNames.favoriteBrand);
//
// const favoriteItemsGroupRef = () => firebase.db()
//   .collectionGroup(collectionNames.favoriteItem);
//
// const load = async (
//   owner: FirebaseID,
//   brandId: FirebaseID,
//   itemId: FirebaseID,
// ): Promise<FavoriteItem | null> => {
//   const doc = await favoriteItemRef(owner, brandId, itemId)
//     .get();
//
//   if (doc.exists) {
//     const data = doc.data() as FavoriteItemData;
//     return {
//       id: doc.id,
//       data,
//     };
//   } else {
//     return null;
//   }
// };
//
// const loadsByOwner = async (owner: FirebaseID): Promise<FavoriteBrand[]> => {
//   const qs = await favoriteaAllRef(owner)
//     .where('checked', '==', true)
//     .get();
//
//   const Brands: FavoriteBrand[] = [];
//   qs.forEach((doc) => {
//     const data = doc.data() as FavoriteBrandData;
//     Brands.push({
//       id: doc.id,
//       data,
//       items: [],
//     });
//   });
//
//   for (const Brand of Brands) {
//     const items: FavoriteItem[] = [];
//     const { brandId } = Brand.data;
//     const is = await favoriteItemsRef(
//       owner,
//       brandId,
//     )
//       .where('checked', '==', true)
//       .get();
//
//     is.forEach((doc) => {
//       const data = doc.data() as FavoriteItemData;
//       items.push({
//         id: doc.id,
//         data,
//       });
//     });
//     Brand.items = items;
//   }
//   return Brands;
// };
//
// const loadFavoriteBrand = (brandId: FirebaseID) => favoriteBrandGroupRef()
//   .where('brandId', '==', brandId)
//   .get();
//
// const loadFavoriteItems = (brandId: FirebaseID) => favoriteItemsGroupRef()
//   .where('brandId', '==', brandId)
//   .get();
//
// const checkBrand = async (owner: FirebaseID, brandId: FirebaseID, checked: boolean) => {
//   const docRef = favoriteBrandRef(owner, brandId);
//
//   firebase.db().runTransaction(async (transaction) => {
//     const doc = await transaction.get(docRef);
//     const now = firebase.now();
//
//     if (!doc.exists) {
//       const newBrand = createNewFavoriteBrand(owner, brandId);
//       newBrand.data.registeredDate = now;
//       newBrand.data.createdBy = owner;
//       newBrand.data.createdDt = now;
//       newBrand.data.updatedBy = owner;
//       newBrand.data.updatedDt = now;
//       transaction.set(docRef, newBrand.data);
//     } else {
//       transaction.update(docRef, {
//         checked,
//         updatedDt: now,
//         updatedBy: owner,
//       });
//     }
//   });
// };
//
// const checkItem = async (owner: FirebaseID, brandId: FirebaseID, itemId: FirebaseID, checked: boolean) => {
//   // Brandのチェックを外すのはブランド単位で trueの場合のみBrandのチェックをする
//   if (checked) {
//     await checkBrand(owner, brandId, checked);
//   }
//
//   const docRef = favoriteItemRef(owner, brandId, itemId);
//
//   firebase.db().runTransaction(async (transaction) => {
//     const doc = await transaction.get(docRef);
//     const now = firebase.now();
//     if (!doc.exists) {
//       const newItem = createNewFavoriteItem(owner, brandId, itemId);
//       newItem.data.registeredDate = now;
//       newItem.data.createdBy = owner;
//       newItem.data.createdDt = now;
//       newItem.data.updatedBy = owner;
//       newItem.data.updatedDt = now;
//       transaction.set(docRef, newItem.data);
//     } else {
//       transaction.update(docRef, {
//         updatedDt: now,
//         updatedBy: owner,
//         checked,
//       });
//     }
//   });
// };
//
// export class SnapShotByBrand {
//   snap: Function | null;
//
//   constructor() {
//     this.snap = null;
//   }
//
//   snapshot(owner: FirebaseID, brandId: FirebaseID, callback: (checked: boolean) => void, fail: (error: Error) => void) {
//     if (this.snap) {
//       throw new Error('already snapshot used');
//     } else {
//       this.snap = favoriteBrandRef(owner, brandId)
//         .onSnapshot((doc) => {
//           let cd = false;
//           if (doc.exists) {
//             const data = doc.data();
//             if (data) {
//               cd = data.checked;
//             }
//           }
//           callback(cd);
//         }, (error) => {
//           fail(error);
//         });
//     }
//   }
//
//   detach() {
//     if (this.snap) this.snap();
//   }
// }
//
// export class SnapShotByItem {
//   snap: Function | null;
//
//   constructor() {
//     this.snap = null;
//   }
//
//   snapshot(owner: FirebaseID, brandId: FirebaseID, itemId: FirebaseID, callback: (checked: boolean) => void, fail: (error: Error) => void) {
//     if (this.snap) {
//       throw new Error('already snapshot used');
//     } else {
//       this.snap = favoriteItemRef(owner, brandId, itemId)
//         .onSnapshot((doc) => {
//           let cd = false;
//           if (doc.exists) {
//             const data = doc.data();
//             console.log(data);
//             if (data) {
//               cd = data.checked;
//             }
//           }
//           callback(cd);
//         }, (error) => {
//           fail(error);
//         });
//     }
//   }
//
//   detach() {
//     if (this.snap) this.snap();
//   }
// }
//
// const favorite = {
//   createNewFavoriteItem,
//   createNewFavoriteBrand,
//   load,
//   checkBrand,
//   checkItem,
//   loadsByOwner,
//   loadFavoriteBrand,
//   loadFavoriteItems,
// };
// //
// export default favorite;
